<div class="footer">
    &copy; Amrize 2025 | <a href="https://www.amrize.com/us/en/privacy-policy.html">Privacy Policy</a> | <a
        href="https://www.amrize.com/us/en/cookie-policy.html">Cookie Policy</a>
</div>